import { render, staticRenderFns } from "./topmalware.vue?vue&type=template&id=3249e844&"
import script from "./topmalware.vue?vue&type=script&lang=js&"
export * from "./topmalware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports